import { Button } from "@twilio-paste/button";
import { Box } from "@twilio-paste/core";
import { ArrowForwardIcon } from "@twilio-paste/icons/esm/ArrowForwardIcon";
import styles from "../../styles";

interface SendMessageButtonProps {
  message: string;
  disabled?: boolean;
  onClick: () => void;
  isMobile?: boolean;
}

const SendMessageButton: React.FC<SendMessageButtonProps> = (
  props: SendMessageButtonProps
) => {
  if (props.isMobile) {
    return (
      <Box style={styles.buttonWrapper}>
        <button
          type="button"
          onClick={() => {
            props.onClick();
          }}
          disabled={props.disabled}
          style={{
            minWidth: 42,
            width: 42,
            height: 42,
            padding: 0,
            borderRadius: 999,
            border: "none",
            backgroundColor: props.disabled ? "#C9D7F2" : "#0B5FFF",
            color: "#FFFFFF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: props.disabled ? "not-allowed" : "pointer",
            opacity: props.disabled ? 0.72 : 1,
          }}
          aria-label="Send message"
        >
          <ArrowForwardIcon
            decorative={false}
            title="Send message"
            color="colorTextInverse"
          />
        </button>
      </Box>
    );
  }

  return (
    <Box style={styles.buttonWrapper}>
      <Button
        variant="primary"
        disabled={props.disabled}
        onClick={() => {
          props.onClick();
        }}
      >
        Send
      </Button>
    </Box>
  );
};

export default SendMessageButton;
